import RoleApplicationRouter         from 'scripts/defa/role-applications/router-role-application-router';
import RoleApplicationController     from 'scripts/defa/role-applications/controller-role-application-controller';
import RoleApplications              from 'scripts/defa/role-applications/collection-role-applications';
import RoleApplication               from 'scripts/defa/role-applications/model-role-application';
import RoleApplicationCollectionView from 'scripts/defa/role-applications/view-role-application-collection-view';
import RoleApplicationContainerView  from 'scripts/defa/role-applications/view-role-application-container';
import RoleApplicationSnippet        from 'scripts/defa/role-applications/view-role-application-snippet';
import RoleApplicationView           from 'scripts/defa/role-applications/view-role-application-view';

import Module                           from 'scripts/module';

const RoleApplicationsModule = new Module('RecipientsModule',{
	collections: {
		RoleApplications
	},
	controllers: {
		RoleApplicationController
	},
	models     : {
		RoleApplication
	},
	routers    : {
		RoleApplicationRouter
	},
	views      : {
		RoleApplicationCollectionView,
		RoleApplicationContainerView,
		RoleApplicationSnippet,
		RoleApplicationView
	}
});
export default RoleApplicationsModule;